"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTenancySubscription = exports.genOCIRedirectURL = exports.getUpgradeCardTitle = void 0;
var Messages = require("../codegen/Messages");
var types_1 = require("../context/types");
var getUpgradeCardTitle = function (type) {
    switch (type) {
        case types_1.TenancySubscriptionTypeEnum.PROMO:
            return Messages.costManagementWidget.promoTitle();
        case types_1.TenancySubscriptionTypeEnum.PROMO_CONSUMED:
            return Messages.costManagementWidget.promoConsumedTitle();
        case types_1.TenancySubscriptionTypeEnum.PROMO_EXPIRED:
            return Messages.costManagementWidget.promoExpiredTitle();
    }
};
exports.getUpgradeCardTitle = getUpgradeCardTitle;
var genOCIRedirectURL = function (url, region, tenant, domain) {
    var urlObj = new URL(url);
    urlObj.searchParams.set("region", region);
    urlObj.searchParams.set("tenant", tenant);
    urlObj.searchParams.set("domain", domain);
    return urlObj.toString();
};
exports.genOCIRedirectURL = genOCIRedirectURL;
var getTenancySubscription = function (type) {
    switch (type) {
        case types_1.TenancySubscriptionTypeEnum.PROMO:
            return {
                type: types_1.TenancySubscriptionTypeEnum.PROMO,
                timeServiceStart: new Date("2022-06-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2022-06-30T00:00:00.000Z"),
                serviceUsedAmount: "100",
                serviceTotalValue: "300",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.ACTIVE,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        case types_1.TenancySubscriptionTypeEnum.PROMO_CONSUMED:
            return {
                type: types_1.TenancySubscriptionTypeEnum.PROMO_CONSUMED,
                timeServiceStart: new Date("2022-06-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2022-06-30T00:00:00.000Z"),
                serviceUsedAmount: "300",
                serviceTotalValue: "300",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.ACTIVE,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        case types_1.TenancySubscriptionTypeEnum.PROMO_EXPIRED:
            return {
                type: types_1.TenancySubscriptionTypeEnum.PROMO_EXPIRED,
                timeServiceStart: new Date("2022-05-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2022-05-31T00:00:00.000Z"),
                serviceUsedAmount: "100",
                serviceTotalValue: "300",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.EXPIRED,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        case types_1.TenancySubscriptionTypeEnum.PAYG:
            return {
                type: types_1.TenancySubscriptionTypeEnum.PAYG,
                timeServiceStart: new Date("2022-06-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2022-06-30T00:00:00.000Z"),
                serviceUsedAmount: "1000",
                serviceTotalValue: "0",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.ACTIVE,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        case types_1.TenancySubscriptionTypeEnum.MONTHLY_COMMITMENT:
            return {
                type: types_1.TenancySubscriptionTypeEnum.MONTHLY_COMMITMENT,
                timeServiceStart: new Date("2021-05-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2023-05-31T00:00:00.000Z"),
                serviceUsedAmount: "2000",
                serviceTotalValue: "200000",
                timeBillingStart: new Date("2022-06-01T00:00:00.000Z"),
                timeBillingEnd: new Date("2022-06-30T00:00:00.000Z"),
                billingUsedAmount: "1000",
                billingTotalValue: "10000",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.ACTIVE,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        case types_1.TenancySubscriptionTypeEnum.ANNUAL_COMMITMENT:
            return {
                type: types_1.TenancySubscriptionTypeEnum.ANNUAL_COMMITMENT,
                timeServiceStart: new Date("2021-03-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2023-03-01T00:00:00.000Z"),
                serviceUsedAmount: "4000",
                serviceTotalValue: "400000",
                timeBillingStart: new Date("2022-03-01T00:00:00.000Z"),
                timeBillingEnd: new Date("2023-03-31T00:00:00.000Z"),
                billingUsedAmount: "20000",
                billingTotalValue: "200000",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.ACTIVE,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
        default:
            return {
                type: types_1.TenancySubscriptionTypeEnum.PROMO_EXPIRED,
                timeServiceStart: new Date("2022-05-01T00:00:00.000Z"),
                timeServiceEnd: new Date("2022-05-31T00:00:00.000Z"),
                serviceUsedAmount: "300",
                serviceTotalValue: "300",
                currencyCode: "USD",
                status: types_1.TenancySubscriptionStatusEnum.EXPIRED,
                organizationType: types_1.TenancySubscriptionOrganizationTypeEnum.STANDALONE,
            };
    }
};
exports.getTenancySubscription = getTenancySubscription;
//# sourceMappingURL=helper.js.map